import { Drawer, Input } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { AppGreen, GrayText } from 'appconstants'
import { ReactComponent as ArrowBack } from 'assets/arrow_back.svg'
import { ReactComponent as Close } from 'assets/close.svg'
import SVGMenu from 'assets/svgmenu'
import StepDrawer from 'components/Drawer/StepDrawer'
import { HeaderContext } from 'hooks/headerContext'
import { useAppSelector } from 'hooks/redux-hooks'
import { toolbarStyle } from 'pages/home/molecules/HomeHeader/index.style'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Pages } from 'routes/types'
import { getRoutePath } from 'utils/routes.utils'
import { isEmpty } from 'utils/validation'

export const Header: React.FC = () => {
  const menuId = 'primary-search-account-menu'
  const { header, hideSearch } = useContext(HeaderContext)
  const [openDrawer, setDrawer] = useState(false)
  const [search, setSearch] = useState('')
  const navigate = useNavigate()
  const selectedOppIdFromStore = useAppSelector((state) => state.lead.selectedOppId)
  let selectedOppId = localStorage.getItem('oppId')
  // Show the ServiceNow ("SN") flag only when an opportunity is active AND it has
  // ServiceNow enabled. `enableServicenow` is populated from the opportunity API
  // response; gating on an active opportunity id prevents a stale flag from
  // lingering after the opportunity is cleared (e.g. back on Home).
  const enableServicenow = useAppSelector((state) => state.opportunity?.enableServicenow)
  const hasOpportunity = !isEmpty(selectedOppIdFromStore) || !isEmpty(selectedOppId)

  const snBadge = hasOpportunity && enableServicenow === true ? (
    <Typography
      id='header_sn_badge'
      component='span'
      sx={{
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
        mr: 1,
        px: 1,
        py: '2px',
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.4,
        color: GrayText,
      }}
    >
      SN
    </Typography>
  ) : null

  const setSearchResult = (e) => {
    setSearch(e.target.value)
    header?.searchResult(e.target.value)
  }

  return header.showHeader ? (
    <Box sx={{ flexGrow: 1, flexWrap: 'wrap' }}>
      <AppBar position='fixed' elevation={2} sx={{ m: 0 }}>
        <Toolbar sx={toolbarStyle}>
          {header.showHomeDrawerIcon && (
            <IconButton
              size='large'
              aria-label='Back'
              aria-controls={menuId}
              aria-haspopup='true'
              onClick={() => {
                setDrawer(true)
              }}
              color='inherit'
            >
              <SVGMenu />
            </IconButton>
          )}
          {header.showBackButton && (
            <IconButton
              size='large'
              aria-label='Back'
              aria-controls={menuId}
              aria-haspopup='true'
              onClick={() => {
                console.log('Back button clicked')
                if (header.showSearch) {
                  header?.searchResult(null)
                } else {
                  navigate(-1)
                }
              }}
              color='inherit'
            >
              <ArrowBack />
            </IconButton>
          )}

          {header.showSearch ? (
            <>
              <Input
                name='headersearch'
                value={search}
                sx={{ flexGrow: 1 }}
                disableUnderline
                autoFocus
                onChange={setSearchResult}
                placeholder={header?.searchPlaceholder}
                autoComplete='off' // TODO: take in as a prop (if required)
              />
              {search !== '' && (
                <IconButton
                  size='large'
                  aria-label='Back'
                  aria-controls={menuId}
                  aria-haspopup='true'
                  onClick={() => {
                    setSearch('')
                    header?.searchResult('')
                  }}
                  color='inherit'
                >
                  <Close />
                </IconButton>
              )}
              <Box sx={{ display: 'flex' }}>
                {snBadge}
                {header.rightIcon}
              </Box>
            </>
          ) : (
            <>
              <Typography
                variant='h1'
                id='header_title'
                noWrap
                component='div'
                sx={{ fontSize: '1rem', flexGrow: 1, color: AppGreen }}
              >
                {header.title}
              </Typography>
              <Box sx={{ display: 'flex' }}>
                {snBadge}
                {header.rightIcon}
              </Box>
            </>
          )}
        </Toolbar>
      </AppBar>

      {header.showHomeDrawerIcon === false ? (
        <Box></Box>
      ) : (
        <Box>
          <Drawer
            variant={'temporary'}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: '300px',
                background: { xs: '#fff', md: '#fdfdfd' },
                mt: {
                  xs: '0px',
                  md: '65px',
                },
              },
              display: { xs: 'block', md: 'none' },
            }}
            anchor={'left'}
            open={openDrawer}
            onClose={() => {
              setDrawer(false)
            }}
          >
            <Box>
              <StepDrawer
                onItemClick={(item) => {
                  setDrawer(false)
                  selectedOppId = localStorage.getItem('oppId')
                  if (isEmpty(selectedOppId)) {
                    if (item.type === Pages.CreateLead || item.type === Pages.PanDetail) {
                      setTimeout(() => {
                        navigate(getRoutePath(item.type))
                      }, 100)
                    }
                  } else {
                    if (item.editableConfig?.editable) {
                      setTimeout(() => {
                        navigate(getRoutePath(item.type))
                      }, 100)
                    }
                  }
                }}
              />
            </Box>
          </Drawer>
          <Drawer
            variant={'permanent'}
            ModalProps={{ keepMounted: true }}
            sx={{
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: '300px',
                background: { xs: '#fff', md: '#fdfdfd' },
                mt: {
                  xs: '0px',
                  md: '65px',
                },
              },
              display: { xs: 'none', md: 'block' },
            }}
            anchor={'left'}
            open={openDrawer}
            onClose={() => {
              setDrawer(false)
            }}
          >
            <Box>
              <StepDrawer
                onItemClick={(item) => {
                  setDrawer(false)
                  selectedOppId = localStorage.getItem('oppId')
                  if (!selectedOppId) {
                    if (item.type === Pages.CreateLead || item.type === Pages.PanDetail) {
                      setTimeout(() => {
                        navigate(getRoutePath(item.type))
                      }, 100)
                    }
                    return
                  }
                  if (item.editableConfig?.editable) {
                    setTimeout(() => {
                      navigate(getRoutePath(item.type))
                    }, 100)
                  }
                }}
              />
            </Box>
          </Drawer>
        </Box>
      )}
    </Box>
  ) : null
}

export default Header
